import { mutatorAction } from 'satcheljs';
import { getAnchorStore } from '../store/anchorStore';

const cleanupWindowAnchorStateMutator: (tabId: string) => void = mutatorAction(
    'cleanupWindowAnchorState',
    (tabId: string): void => {
        const { anchorMap } = getAnchorStore();
        const prefix = `${tabId}:`;
        for (const key of anchorMap.keys()) {
            if (key.startsWith(prefix)) {
                anchorMap.delete(key);
            }
        }
    }
);

export default cleanupWindowAnchorStateMutator;
